import { FormControl, Slider, Stack, TextField } from '@mui/material';
import SettingCard from '@/components/SettingCard';
import { useNode } from '@craftjs/core';
import useResponsiveValues, { ResponsiveValue } from '../hooks/useResponsiveValues';

interface VerticalSpacerBlockProps {
  height?: number | ResponsiveValue<number>;
}

const VerticalSpacerBlock = ({ height = 10 }: VerticalSpacerBlockProps) => {
  const {
    connectors: { connect, drag },
  } = useNode();

  const responsive = useResponsiveValues();

  return <div ref={(ref) => connect(drag(ref))} style={{ height: responsive.getValue(height) + 'px' }} />;
};

export const VerticalSpacerSettings = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const responsive = useResponsiveValues();

  return (
    <SettingCard title="Espacio">
      <FormControl fullWidth={true} margin="normal" component="fieldset">
        <Stack direction={'row'} spacing={2}>
          <Slider
            step={8}
            marks
            min={8}
            max={100}
            value={responsive.getValue(props.height)}
            onChange={(_, value) =>
              setProp((props: { height: number }) => {
                props.height = responsive.setValue(props.height, value);
                return props;
              })
            }
          />
          <TextField
            size="small"
            value={responsive.getValue(props.height)}
            onChange={(e) =>
              setProp((props: { height: number }) => {
                props.height = Number(responsive.setValue(props.height, e.target.value));
                return props;
              })
            }
          />
        </Stack>
      </FormControl>
    </SettingCard>
  );
};

VerticalSpacerBlock.craft = {
  props: {
    height: 20,
  },
  related: {
    settings: VerticalSpacerSettings,
  },
};

export default VerticalSpacerBlock;
